import { SpinnerContainer, SpinnerOverlay } from "./spinner.styles";

export const Spinner = () => (
  <SpinnerOverlay>
    <SpinnerContainer />
  </SpinnerOverlay>
);
